import { Reaction } from "suus-api"
import { getContextName, ViewContext } from "concerns/useContextName"

export class MemberReaction {
  constructor(
    public id: number,
    public name: string,
    public link: string,
    public reaction: string,
    public avatar_url: string
  ) {}

  public static fromReaction(
    reaction: Reaction,
    viewContext: ViewContext
  ): MemberReaction {
    return new MemberReaction(
      reaction.creator.id,
      getContextName(viewContext, reaction.creator),
      reaction.creator.url,
      reaction.emoji,
      reaction.creator.avatar_url
    )
  }
}
